var React = require('react');
var ChangeStepButtons = require('../ChangeStepButtons/changeStepButtons.jsx');
var LicenseInformation = require('./ReactDependencies/LicenseInformation.jsx');
var BoardCredentials = require('./ReactDependencies/BoardCredentials.jsx');
var BoardCertifications = require('./ReactDependencies/BoardCertifications.jsx');
var ActiveLicenses = require('./ReactDependencies/ActiveLicenses.jsx');
var memberTypeChecker = require('../../../../Scripts/React/MemberTypeChecker.jsx').step4;
var { $form } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');

class Step4 extends React.Component {
    constructor(props) {
        super(props);

        this.bindFunctions();
    }

    componentDidMount() {
        if (!this.props.appState.isInternational) {
            var stateFetchOptions = {
                queryString: () => '?countryCode=' + 'USA'
            }
            this.props.loadApiData('statesByCountry', stateFetchOptions);
        }

        this.props.loadApiData('districts');
    }

    bindFunctions() {
        this.formSubmitCleanup = this.formSubmitCleanup.bind(this);
        this.hasValidActiveLicense = this.hasValidActiveLicense.bind(this);
        this.prevStepValid = this.prevStepValid.bind(this);
        this.nextStepValid = this.nextStepValid.bind(this);
    }

    prevStepValid() {
        return this.props.appState.currentStep > 3 || this.props.appState.debugMode;
    }

    hasValidActiveLicense() {
        // here, we just need to check if we have 1 or more active licenses. 
        // if any active licenses to exist, they have their own field validation which will automatically run
        return memberTypeChecker.hideActiveLicenses(this.props.appState.appType)
            || (this.props.stepState.activeLicenses && this.props.stepState.activeLicenses.length);
    }

    formSubmitCleanup() {

        // for any subspecialties that got deleted
        // find the corresponding record in api data, and get rid of the CusDemographicId prop
        this.props.stepState.boardSubSpecialtiesToDelete.map((deletedSub) => {
            this.props.apiData.activeSubboards.filter((sub) => {
                return sub.CusDemographicId === deletedSub.CusDemographicId;
            }).map((match) => {
                delete match.CusDemographicId;
            });
        });

        this.props.updateApplicationState('apiData', this.props.apiData);
        this.props.updateArbitraryStepState('boardSubSpecialtiesToDelete', [], 4);
    }

    nextStepValid() {
        if (this.props.appState.debugMode) {
            return this.props.appState.currentStep < 6 || this.props.appState.debugMode;
        }

        return (this.hasValidActiveLicense() && this.props.appState.currentStep < 6) || this.props.appState.debugMode;
    }
    goNextStep(event, props) {
        event.preventDefault();
        props.updateApplicationState('primaryPracticeLocation', props.stepState.primaryPracticeLocation);
        props.updateApplicationState('primaryDistrictLocation', props.stepState.primaryDistrictLocation);
        props.goToStep(event, 5, this.formSubmitCleanup());
    }

    //(event) => this.props.goToStep(event, 5, this.formSubmitCleanup())
    render() {
        const myForm = <$form onSubmit={(event) => this.goNextStep(event, this.props)} ref={c => { this.form = c }}>
            <div className={'row'}>
                <div className={'col-md-8'}>
                    <LicenseInformation {...this.props} />
                    <ActiveLicenses {...this.props} />
                    <BoardCertifications {...this.props} />
                    <BoardCredentials {...this.props} />
                </div>
                <div className={'col-md-4'}>
                    {this.props.cartComponent}
                </div>
            </div>

            <ChangeStepButtons
                disableUI={this.props.appState.disableUI}
                nextStepValid={this.nextStepValid}
                prevStepValid={this.prevStepValid}
                goPrevStep={this.props.goPrevStep}
                currentStep={this.props.appState.currentStep} />

        </$form>;
        return <div className={"step-4-container"}>

            {myForm}

        </div>;
    }
}

module.exports = Step4;